import { display } from '../../common';
import { Project } from '~/types/project';

export default function developer(project: Project) {
  return display(project?.installer?.company?.name);
}